import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Row, Col, Table, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label } from "reactstrap";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import { api, mensajeError } from "./gastosFlujoUtil";

// Proveedores de gastos: catálogo aparte de Proveedores (mercancía) para no
// mezclarlos con su estado de cuenta de CxP.
const CAMPOS = [
  ["nombre", "Nombre *"],
  ["rfc", "RFC"],
  ["contacto", "Contacto"],
  ["telefono", "Teléfono"],
  ["email", "Email"],
  ["observaciones", "Observaciones"],
];

function ProveedoresGastos() {
  const { user } = useContext(AuthContext);
  const [proveedores, setProveedores] = useState([]);
  const [buscar, setBuscar] = useState("");
  const [form, setForm] = useState(null);
  const [guardando, setGuardando] = useState(false);

  const cargar = () =>
    api.get("proveedoresGastos").then(setProveedores).catch((e) => Swal.fire({ icon: "error", title: "No se pudieron cargar", text: mensajeError(e) }));

  useEffect(() => {
    cargar();
  }, []);

  const lista = useMemo(() => {
    const t = buscar.trim().toLowerCase();
    return proveedores.filter((p) => !t || CAMPOS.some(([c]) => String(p[c] || "").toLowerCase().includes(t)));
  }, [proveedores, buscar]);

  async function guardar() {
    if (!String(form.nombre || "").trim()) return Swal.fire({ icon: "warning", title: "Falta el nombre" });
    setGuardando(true);
    try {
      const body = Object.fromEntries(CAMPOS.map(([c]) => [c, form[c] || ""]));
      if (form._id) await api.patch(`proveedoresGastos/${form._id}`, body);
      else await api.post("proveedoresGastos", body);
      setForm(null);
      await cargar();
    } catch (e) {
      Swal.fire({ icon: "error", title: "No se guardó", text: mensajeError(e) });
    }
    setGuardando(false);
  }

  async function cambiarActivo(p) {
    try {
      await api.patch(`proveedoresGastos/${p._id}`, { is_active: p.is_active === "No" ? "Si" : "No" });
      cargar();
    } catch (e) {
      Swal.fire({ icon: "error", title: "No se pudo cambiar", text: mensajeError(e) });
    }
  }

  if (!user.menu_gastos) return <Header />;

  return (
    <>
      <Header />
      <div className="card col-12" style={{ padding: "18px 22px" }}>
        <Row className="align-items-center">
          <Col md={6}>
            <h3 style={{ margin: 0 }}>Proveedores de gastos</h3>
          </Col>
          <Col md={6} style={{ textAlign: "right" }}>
            {user.gastos_create ? (
              <Button size="sm" color="success" onClick={() => setForm({})}>
                <i className="fas fa-plus"></i> Nuevo proveedor
              </Button>
            ) : null}{" "}
            <Button size="sm" color="danger" href="/MenuGastos">Regresar</Button>
          </Col>
        </Row>
        <Row style={{ margin: "14px 0 8px" }}>
          <Col md={4}>
            <Input bsSize="sm" placeholder="Buscar..." value={buscar} onChange={(e) => setBuscar(e.target.value)} />
          </Col>
        </Row>
        <Table size="sm" striped borderless className="table-responsive-xl">
          <thead>
            <tr>{CAMPOS.map(([c, e]) => <th key={c}>{e.replace(" *", "")}</th>)}<th>Activo</th><th></th></tr>
          </thead>
          <tbody>
            {lista.map((p) => (
              <tr key={p._id} style={{ opacity: p.is_active === "No" ? 0.5 : 1 }}>
                {CAMPOS.map(([c]) => <td key={c}>{c === "nombre" ? <b>{p[c]}</b> : p[c]}</td>)}
                <td>{p.is_active}</td>
                <td style={{ whiteSpace: "nowrap", textAlign: "right" }}>
                  {user.gastos_create ? (
                    <>
                      <Button size="sm" color="primary" title="Editar" onClick={() => setForm({ ...p })}><i className="fas fa-edit"></i></Button>{" "}
                      <Button size="sm" color={p.is_active === "No" ? "success" : "secondary"} title={p.is_active === "No" ? "Activar" : "Desactivar"} onClick={() => cambiarActivo(p)}>
                        <i className={p.is_active === "No" ? "fas fa-check" : "fas fa-ban"}></i>
                      </Button>
                    </>
                  ) : null}
                </td>
              </tr>
            ))}
            {!lista.length ? <tr><td colSpan={CAMPOS.length + 2} style={{ color: "#94a3b8", textAlign: "center" }}>Sin proveedores de gastos.</td></tr> : null}
          </tbody>
        </Table>
      </div>

      <Modal isOpen={!!form} toggle={() => setForm(null)}>
        <ModalHeader toggle={() => setForm(null)}>{form && form._id ? "Editar proveedor" : "Nuevo proveedor de gastos"}</ModalHeader>
        <ModalBody>
          {form
            ? CAMPOS.map(([c, etiqueta]) => (
                <div key={c} style={{ marginBottom: 8 }}>
                  <Label>{etiqueta}</Label>
                  <Input value={form[c] && form[c] !== "NA" ? form[c] : ""} onChange={(e) => setForm({ ...form, [c]: e.target.value })} />
                </div>
              ))
            : null}
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardar} disabled={guardando}>{guardando ? "Guardando..." : "Guardar"}</Button>
          <Button color="secondary" onClick={() => setForm(null)}>Cerrar</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ProveedoresGastos;
